import {type StripeGateway, type IStripeContext} from '../../../models/stripe';
import {PeachPayCustomer} from '../../../reducers/peachPayCustomerReducer';
import {getLocaleText} from '../../../util/translation';
import affirmImageURL from '../../../../img/marks/affirm.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';
import affirmBadgeURL from '../../../../img/badge/affirm.svg';

function initStripeAffirmMethod(): StripeGateway {
	return {
		config: {
			name: Feature.metadata<string>(FeatureFlag.STRIPE_AFFIRM_GATEWAY, 'title') ?? 'Affirm',
			gatewayId: 'peachpay_stripe_affirm',
			description: getLocaleText('After selecting pay you will be redirected to complete your payment.'),
			assets: {
				title: {src: affirmImageURL},
				badge: {src: affirmBadgeURL},
			},
		},
		async tokenize(context) {
			const {stripe} = context;

			const {paymentMethod, error} = await stripe.createPaymentMethod({
				type: 'affirm',
				billing_details: PeachPayCustomer.stripeBillingDetails(),
			});

			if (error) {
				const message = error.message ?? 'Failed to tokenize payment method.';

				return [null, {
					paymentStatus: 'creationfailed',
					note: message,
				}];
			}

			if (!paymentMethod?.id) {
				return [null, {
					paymentStatus: 'creationfailed',
					note: 'Failed to tokenize payment method.',
				}];
			}

			return [paymentMethod.id, {}];
		},
		async confirm(context: IStripeContext, clientSecret: string, intermediateURL: string) {
			const {stripe} = context;

			const {paymentIntent, error} = await stripe.confirmAffirmPayment(clientSecret, {return_url: intermediateURL});

			if (error) {
				const message = error.message ?? 'Failed to confirm payment.';
				return [null, {
					note: message,
				}];
			}

			if (paymentIntent) {
				return ['success', {}];
			}

			return [null, {}];
		},
	};
}

export {initStripeAffirmMethod};
